import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-driver-new',
  templateUrl: './driver-new.component.html',
  styleUrls: ['./driver-new.component.scss']
})
export class DriverNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
